
import { mapState } from 'vuex'
export default {
  props: {
    value: {
      type: String,
      default: 'international',
    },
  },
  computed: {
    ...mapState({
      site: (state) => state.site,
    }),
    isIdSite() {
      return this.site.toUpperCase() === 'ID'
    },
    queryType() {
      return this.value
    },
  },
  methods: {
    switchTab(type) {
      this.$emit('input', type)
      this.$emit('change', type)
    },
  },
}
